import * as React from 'react'

import Stack from '@mui/material/Stack'

import ResponsiveContainer from 'components/atomic/organisms/responsive-container'
import FullDescription from 'pages/path/full-description'
import Syllabus from 'pages/path/syllabus'
import ResourcesGrid from 'components/atomic/molecules/resources-grid'
import PlatformUSPs from 'pages/path/platform-usps/v1'
import FeaturesGrid from 'components/atomic/molecules/features-grid'
import RelatedPaths from 'pages/path/related-paths'
import CTACommunity from 'pages/path/cta-community'
import CTAStudents from 'pages/path/cta-students'
import Testimonial from 'components/atomic/molecules/testimonial'
import CTACertificate from 'pages/path/cta-certificate'
import CTASimple from 'pages/path/cta-simple'
import UserGoals from 'pages/path/user-goals'
import Projects from 'pages/path/projects/v1'
import Outcomes from 'pages/path/outcomes'

import { computeUserCount } from 'utils/paths'
import { Path } from 'types/types'

const PathContent = ({ path }: { path: Path }) => {
    return (
        <ResponsiveContainer maxWidth="lg">
            <Stack pt="5rem" spacing="6rem">
                <UserGoals {...path} />
                <Outcomes {...path} />
                <FeaturesGrid
                    completionTime={path.completion_time}
                    difficulty={path.difficulty}
                    grantsCertificate={path.grants_certificate}
                />
                <Syllabus {...path} />
                <CTAStudents enrolled={computeUserCount(path)} type={path.goal} />
                <Projects {...path} />
                <FullDescription {...path} />
                <CTACommunity />
                <PlatformUSPs />
                <CTASimple type={path.goal} />
                <ResourcesGrid resourcesCount={path.resources_count} />
                <Testimonial
                    name={path.testimonial.name}
                    avatar={path.testimonial.avatar_url}
                    occupation={path.testimonial.occupation}
                    quote={path.testimonial.quote}
                />
                {path.grants_certificate && <CTACertificate />}
                <RelatedPaths {...path} />
            </Stack>
        </ResponsiveContainer>
    )
}

export default PathContent
